
import { useEffect } from 'react'
import { MenuItem, Select } from '@mui/material';
import Alert from '@mui/material/Alert';
import { useDispatch, useSelector } from 'react-redux';
import { getAllRoles, getAssignableRoles, unsetLoading, setLoading, resetResponseState } from '../../store/appAction';
import { isObjectEmpty } from '../../helpers/genericHelper';
import { roleSorter } from '../../helpers/userHelper'
import PropTypes from 'prop-types';

const DEFAULT_ROLE = 'farmer'
const DEFAULT_ROLENAME = 'Farmer'

const isRoleAssignable = (assignable, role) => {
    return (assignable?.findIndex((e) => e.name === role) >= 0)
}

const getSingleAssignableRoleLst = (type, roles) => {
    let newRole = structuredClone({ name: DEFAULT_ROLE, extraProperties: { DisplayName: DEFAULT_ROLENAME } })
    if (type && !isObjectEmpty(roles) ) {
        newRole.name = type
        newRole.extraProperties.DisplayName = roles[type]?.displayName || type
    }
    return [newRole]
}

const getUsableValue = (value,validAssignableRoles) =>{
    if( value ){
        return value
    } else if (isRoleAssignable(validAssignableRoles, DEFAULT_ROLE)){
        return DEFAULT_ROLE
    } else if (!validAssignableRoles?.length){
        return DEFAULT_ROLE
    }
    return validAssignableRoles[0].name
}

export default function UserRolesSelect({ value = '', disabled, ...other }) {
    const dispatch = useDispatch();

    const userAssignableRoles = useSelector(state => state.common.assignableRoles);
    const allRoles = useSelector(state => state.common.allRoles);
    const { successMsg, errorMsg } = useSelector(state => state.common);

    useEffect(() => {
        if (!(userAssignableRoles?.length)) {
            dispatch(setLoading)
            dispatch(getAssignableRoles())
        }
        if (isObjectEmpty(allRoles)) {
            dispatch(setLoading)
            dispatch(getAllRoles())
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (successMsg || errorMsg) {
            dispatch(unsetLoading());
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [successMsg, errorMsg]);

    const getValidAssignableRoles = (roles, type) => {

        if (userAssignableRoles?.length > 0 && (isRoleAssignable(userAssignableRoles, type) || type === '') ) {
            //return assignable roles if there are any and the type can be assigned.
            // Making sure consultant and farmer come first
            return roleSorter.sort(userAssignableRoles)
        }
        // the current user isn't allowed to change or access the 
        // role of the user being edited  or there isn't a type set
        return getSingleAssignableRoleLst(type, allRoles)
    }

    const validAssignableRoles = getValidAssignableRoles(userAssignableRoles, value)
    const selectValue = getUsableValue(value,validAssignableRoles)  
    const selectDisabled = disabled || validAssignableRoles.length < 2
    return (
        <>
            <Select
                disabled={selectDisabled}
                value={selectValue}
                {...other}
                inputProps={{'aria-label':'User Role', "aria-labelledby":null}}
            >
                {validAssignableRoles.map((userRole) => (
                    <MenuItem id={userRole.name} key={userRole.name} value={userRole.name}>
                        {userRole?.extraProperties?.DisplayName}
                    </MenuItem>
                ))}
            </Select>
            {errorMsg &&
                <Alert severity="error" onClose={() => { dispatch(resetResponseState()); }} >{errorMsg}</Alert>}
        </>
    )
}

UserRolesSelect.propTypes = {
    value: PropTypes.string,
    disabled: PropTypes.bool
}